var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireExtinguisherSafetySvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.668 17.5149C21.668 17.4638 20.4936 11.1319 20.6978 7.25105C20.7999 5.41275 20.3914 4.03403 19.5233 3.16597C18.7064 2.34893 17.7361 2.29785 17.4808 2.29785H8.90212C8.90212 1.83828 8.59574 1.48081 8.18724 1.3787L3.5915 0.0510602C3.28512 -0.0510513 2.97874 -1.95173e-05 2.72344 0.204251C2.46813 0.408522 2.31494 0.714905 2.31494 1.02129V5.61703C2.31494 5.92341 2.46813 6.22979 2.6724 6.43406C2.87667 6.58725 3.0809 6.63833 3.28517 6.63833C3.38728 6.63833 3.48944 6.58725 3.59155 6.63833L8.18729 5.31069C8.59578 5.1575 8.90217 4.80004 8.90217 4.34046H10.8426V6.68941C8.39151 7.14899 6.50214 9.34474 6.50214 11.8979V22.9787C6.50214 23.5404 6.96171 23.9999 7.5234 23.9999H16.1532C16.7149 23.9999 17.1744 23.5404 17.1234 22.9787V11.8979C17.1234 9.3447 15.2851 7.20002 12.8851 6.68936V4.34042H17.532C17.532 4.34042 17.8383 4.34042 18.1447 4.6468C18.5532 5.10637 18.7575 5.97444 18.7064 7.19997C18.5021 11.3361 19.6766 17.6681 19.7277 17.9234C19.8298 18.3829 20.2383 18.7404 20.6979 18.7404C20.8 18.7404 20.8511 18.7404 20.8511 18.6893C21.4127 18.5872 21.7702 18.0766 21.668 17.5149ZM6.91063 3.57446L4.30638 4.28934V2.29785L6.91063 3.06381V3.57446ZM15.183 11.8979V22.0085H8.54466V11.8979C8.54466 10.0596 10.0255 8.57874 11.8638 8.57874C13.7021 8.57869 15.183 10.0596 15.183 11.8979Z",
    fill: "#9393B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireExtinguisherSafetySvgrepocom);
export default __webpack_public_path__ + "static/media/fire-extinguisher-safety_svgrepo.com.ced709b58bc0c18fe696e4a9c654e6e7.svg";
export { ForwardRef as ReactComponent };